<template>
  <div class="map-container">
    <MapWrapper
      v-if="active"
      show-bounds
      any-zoom
      :show-popups="false"
      :level-headings="false"
    />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import MapWrapper from '@/components/public/TheMap/MapWrapper.vue'

const components = {
  MapWrapper,
}

const props = {
  active: Boolean,
}

@Component({ components })
export default class WizardMap extends Vue.extend({ props }) {}

</script>

<style scoped>

.map-container {
  height: 300px;
  width: 100%;
}

</style>
